import { ANALYTICS_TRIGGERS } from '@24i/nxg-sdk-smartott-shared/src/analytics/constants';
import { AdEvent } from '@24i/nxg-sdk-photon/src/analytics/player';

import { Payload, AdEventResult } from '../types';
import { mapBase } from './mapBase';
import { EVENTS } from '../constants';

export const mapAdEvent = (triggerName: ANALYTICS_TRIGGERS, payload: Payload): AdEventResult => {
    const adPayload = payload?.payload as unknown as AdEvent;
    const assetDuration = payload?.payload?.asset?.duration;
    let adPlaybackPosition = adPayload?.adPlaybackPosition;
    if (
        !Number.isFinite(adPlaybackPosition) &&
        typeof assetDuration === 'number' &&
        Number.isFinite(assetDuration)
    ) {
        adPlaybackPosition = assetDuration * 1000;
    }
    const action =
        triggerName === ANALYTICS_TRIGGERS.AD_COMPLETE ? EVENTS.AD_COMPLETE : triggerName;
    return {
        ...mapBase(payload),
        action,
        event_trigger: triggerName,
        thing_id: payload?.payload?.asset?.id || '',
        ad_id: adPayload?.adId,
        ad_playback_position: Math.round(adPlaybackPosition),
        ad_playback_duration: adPayload?.adDuration || 0,
        ad_position: adPayload?.adPosition,
    };
};
